import { CircularProgress } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect } from 'react';

// import { useHistory } from 'react-router';
import { ReactComponent as QuestionIcon } from '../../../common/images/staking/icon-question-mark.svg';
import { ReactComponent as BigQuestionIcon } from '../../../common/images/staking/icon-question-mark-big.svg';
// import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';
// import { Web3StateContext } from '../../../contexts/app-state-context/web3/web3-state.context';
import { useStarsChefContract } from '../../../hooks/stars-chef-contract.hooks';
// import { MetaMaskModal } from '../../common/modal/MetaMaskModal.component';
// import { OkModal } from '../../common/modal/OkModal.component';
import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './StakingCard.module.css';
import {
  // StakingCardButtons,
  UnStakingCardButtons,
} from './StakingCardInputs.comonent';
import { StakingWallet } from './StakingWallet.component';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    topRightToolTip: {
      maxWidth: '25ch',
      background: '#C3565C',
    },
    toolTips: {
      maxWidth: '35ch',
      background: '#C3565C',
    },
    loader: {
      color: 'white',
    },
  }),
);

interface Props {
  asset: string;
  lpTokenContract: string;
  isLoggedIn: boolean;
  poolId: number;

  handleBuyMoreStars?: (lpTokenAddress: string) => void;
}

export const StakingCard: React.FC<Props> = props => {
  const classes = useStyles();
  const topRightToolTipInfo =
    props.asset.toUpperCase() === 'STARS'
      ? 'Staking pool for STARS holders'
      : 'Staking pool for Uniswap LPs on the STARS_ETH pool';

  // const { metaMaskInitialized } = useContext(Web3StateContext);
  // const { setModal } = useContext(ModalStateContext);
  const stakingContract = useStarsChefContract(props.poolId);

  const [starsStakedAmt, setStarsStakedAmt] = React.useState('0');
  const [rewardsAmt, setRewardsAmt] = React.useState('0');
  const [totalStakedInPoolAmt, setTotalStakedInPoolAmt] =
    React.useState<string>('0');
  const [APR, setAPR] = React.useState<string>('0');
  const [walletBal, setWalletBal] = React.useState<string>('0');

  const [isApproved, setIsApproved] = React.useState<boolean>(false);
  // const [isStaking, setIsStaking] = React.useState<boolean>(false);
  const [isUnStaking, setIsUnStaking] = React.useState<boolean>(false);

  // const [stakeAmt, setStakeAmt] = React.useState<string>('');
  const [unStakeAmt, setUnStakeAmt] = React.useState<string>('');

  // const [stakeLoading, setStakeLoading] = React.useState(false);
  const [unStakeLoading, setUnStakeLoading] = React.useState(false);
  const [claimRewardsLoading, setClaimRewardsLoading] = React.useState(false);

  const setupStakingCard = async () => {
    try {
      const poolSupply = await stakingContract.getTotalStakedInPool();
      const stakingAmount = await stakingContract.getStakingAmountFromChef();
      const userRewards = await stakingContract.getRewardsAmount();
      const apr = await stakingContract.getAPR();
      const stakingContractApproved = await stakingContract.checkApproved();
      const walletBalance = await stakingContract.getWalletBalance();
      setTotalStakedInPoolAmt(poolSupply);
      setStarsStakedAmt(stakingAmount);
      setRewardsAmt(
        parseFloat(userRewards).toLocaleString('en-us', {
          maximumFractionDigits: 2,
          useGrouping: true,
        }),
      );
      setAPR(apr);
      setIsApproved(stakingContractApproved);
      setWalletBal(walletBalance);
    } catch (e) {
      console.error('Failed to get staking info', e);
    }
  };

  useEffect(() => {
    void setupStakingCard();
  }, [stakingContract.initialized]);

  // const handleStakeAmtChange = React.useCallback((value: string) => {
  //   setStakeAmt(value || '');
  // }, []);

  const handleUnStakeAmtChange = React.useCallback((value: string) => {
    setUnStakeAmt(value || '');
  }, []);

  const buyMoreStarsOnClick = () => {
    if (props.handleBuyMoreStars) {
      props.handleBuyMoreStars(props.lpTokenContract);
    }
  };

  // const handleNotLoggedIn = () => {
  //   setModal(
  //     OkModal('Please login to access staking.', () => {
  //       history.push('/login');
  //     }),
  //   );
  // };

  // const handleApprove = async () => {
  //   if (!props.isLoggedIn) {
  //     handleNotLoggedIn();
  //     return;
  //   }
  //   if (!metaMaskInitialized) {
  //     setModal(MetaMaskModal());
  //     return;
  //   }

  //   const didApprove = await stakingContract.approveStarsChefContract();
  //   setIsApproved(didApprove);
  // };

  // const stakeOnClick = () => {
  //   if (!props.isLoggedIn) {
  //     handleNotLoggedIn();
  //     return;
  //   }
  //   setIsStaking(true);
  //   setIsUnStaking(false);
  // };

  // const handlePlaceStake = async () => {
  //   try {
  //     setStakeLoading(true);
  //     const didStake = await stakingContract.depositToChef(stakeAmt);
  //     if (didStake) {
  //       setIsStaking(false);
  //       setStakeAmt('');
  //       await setupStakingCard();
  //     }
  //     setStakeLoading(false);
  //   } catch (e) {
  //     console.error(`Failed to place stake in ${props.asset} pool`, e);
  //   }
  // };

  const unStakeOnClick = () => {
    setIsUnStaking(true);
    // setIsStaking(false);
  };

  const handlePlaceUnStake = async () => {
    try {
      setUnStakeLoading(true);
      const didUnStake = await stakingContract.withdrawFromChef(unStakeAmt);
      if (didUnStake) {
        setIsUnStaking(false);
        setUnStakeAmt('');
        await setupStakingCard();
      }
      setUnStakeLoading(false);
    } catch (e) {
      console.error(`Failed to unstake in ${props.asset} pool `, e);
    }
  };

  const handleClaimRewards = async () => {
    try {
      setClaimRewardsLoading(true);
      const didClaim = await stakingContract.collectChefRewards();
      if (didClaim) {
        await setupStakingCard();
      }
      setClaimRewardsLoading(false);
    } catch (e) {
      console.error(
        `Failed to place collect reward in ${props.asset} pool `,
        e,
      );
    }
  };

  return (
    <div>
      <div
        className={
          isApproved ? styles.approvedsStakingCard : styles.stakingCard
        }
      >
        <h1 className={styles.stakingAssetHeader}>{`${props.asset} POOL`}</h1>
        <div className={styles.stakingHeader}>
          {parseFloat(totalStakedInPoolAmt).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
        <div className={styles.stakingSubHeader}>{`${props.asset} STAKED`}</div>
        <div className={styles.specialRow}>
          <p className={styles.stakingText}>
            My rewards{' '}
            <Tooltip
              title="Total rewards accumulated from this pool"
              placement="top"
              classes={{ tooltip: classes.toolTips }}
            >
              <QuestionIcon className={styles.questionMarkToolTip} />
            </Tooltip>
          </p>
          <p className={styles.bigZeroContainer}>
            <span className={styles.bigZero}>{rewardsAmt}</span> MOGUL
          </p>
        </div>
        <div className={styles.cardRow}>
          <p className={styles.stakingText}>
            My total stake{' '}
            <Tooltip
              title={`Total amount of ${props.asset} you have staked in this pool`}
              placement="top"
              classes={{ tooltip: classes.toolTips }}
            >
              <QuestionIcon className={styles.questionMarkToolTip} />
            </Tooltip>
          </p>
          <p className={styles.bigZeroContainer}>
            <span className={styles.bigZero}>
              {parseFloat(starsStakedAmt).toLocaleString('en-us', {
                maximumFractionDigits: 2,
                useGrouping: true,
              })}
            </span>{' '}
            {props.asset}
          </p>
        </div>
        <div className={styles.cardRow}>
          <p className={styles.stakingText}>
            APR{' '}
            <Tooltip
              title="Annual percentage rate of rewards earned through participating in this pool"
              placement="top"
              classes={{ tooltip: classes.toolTips }}
            >
              <QuestionIcon className={styles.questionMarkToolTip} />
            </Tooltip>
          </p>
          <p className={styles.bigZeroContainer}>{APR}%</p>
        </div>
        {
          <Button
            color={Colors.COLOR_SCHEME_3}
            className={styles.claimButton}
            onClick={handleClaimRewards}
            disabled={rewardsAmt === '0'}
          >
            {claimRewardsLoading ? (
              <CircularProgress className={classes.loader} />
            ) : (
              'CLAIM'
            )}
          </Button>
        }
        <UnStakingCardButtons
          loading={unStakeLoading}
          isApproved={isApproved}
          isUnStaking={isUnStaking}
          unStakeAmt={unStakeAmt}
          unStakeOnClick={unStakeOnClick}
          handleUnStakeAmtChange={handleUnStakeAmtChange}
          starsStakedAmt={starsStakedAmt}
          handlePlaceUnStake={handlePlaceUnStake}
        />
        {/* <StakingCardButtons
          loading={stakeLoading}
          isApproved={true}
          isStaking={isStaking}
          stakeAmt={stakeAmt}
          stakeOnClick={stakeOnClick}
          handleApprove={handleApprove}
          walletBal={walletBal}
          handleStakeAmtChange={handleStakeAmtChange}
          handlePlaceStake={handlePlaceStake}
        /> */}
        <div className={styles.topRightTooltip}>
          <Tooltip
            title={topRightToolTipInfo}
            placement="top"
            classes={{ tooltip: classes.topRightToolTip }}
          >
            <BigQuestionIcon className={styles.questionMarkToolTip} />
          </Tooltip>
        </div>
      </div>
      {isApproved && (
        <StakingWallet
          walletBal={parseFloat(walletBal).toLocaleString('en-us', {
            maximumFractionDigits: 2,
            useGrouping: true,
          })}
          onClick={buyMoreStarsOnClick}
          asset={props.asset}
        />
      )}
    </div>
  );
};
